module.exports = __webpack_public_path__ + "static/media/help-question-mark.037958db.svg";